import { styled } from "styled-components";
import { colors } from "./colors";

const BARLOW = "Barlow";
const LORA = "Lora";
const UBUNTU = "Ubuntu";
const UBUNTU_MONO = "Ubuntu Mono";

export const H1 = styled.h1`
  margin: 0;
  font-family: ${LORA};
  font-size: 28px;
  font-weight: bold;
  line-height: 34px;
  font-weight: bold;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const H2 = styled.h2`
  margin: 0;
  font-family: ${LORA};
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
  font-style: normal;
  letter-spacing: 2%;
  color: ${colors.dark};
`;

export const H3 = styled.h3`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  font-style: normal;
  letter-spacing: 2%;
  color: ${colors.dark};
`;

export const H4 = styled.h4`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const H5 = styled.h4`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const Body = styled.p`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 15px;
  line-height: 26px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;
export const Body60 = styled(Body)`
  opacity: 0.6;
`;

export const Small = styled.p`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const Mini = styled.p`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const ButtonText = styled.p`
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const TextButtonText = styled.p`
  /* Button TextOnly */
  margin: 0;
  font-family: ${UBUNTU};
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const Numbers = styled.p`
  margin: 0;
  font-family: ${BARLOW};
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const MonoText = styled.p`
  margin: 0;
  font-family: ${UBUNTU_MONO};
  font-size: 16px;
  line-height: 26px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.medium};
`;
